var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.GridTileTipe = {
  LEFT:0,
  CENTER:1,
  RIGHT:2,
}

EHDI.game.GridTile = function() {
    EHDI.aka.Container.call(this);
};

EHDI.game.GridTile.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.GridTile.prototype.init = function (type, scorecount) {
  this._textures = [];
  this._glow;
  this._sprite;
  this._glowSprite;
  this._scoreCount = scorecount;
  this._countSprite;

  if (type == EHDI.game.GridTileTipe.CENTER) {
    this._textures.push(EHDI.Assets.images["grid1a"]);
    this._textures.push(EHDI.Assets.images["grid2a"]);
    this._textures.push(EHDI.Assets.images["grid3a"]);
    this._textures.push(EHDI.Assets.images["gridglow1"]);
  } else {
    this._textures.push(EHDI.Assets.images["grid1b"]);
    this._textures.push(EHDI.Assets.images["grid2b"]);
    this._textures.push(EHDI.Assets.images["grid3b"]);
    this._textures.push(EHDI.Assets.images["gridglow2"]);
  }

  this._textures.push(EHDI.Assets.images[this._scoreCount.toString()]);
  this._textures.push(EHDI.Assets.images[this._scoreCount.toString()+"a"]);
  this._textures.push(EHDI.Assets.images[this._scoreCount.toString()+"b"]);

  if(this._sprite == null) {
    this._sprite = new EHDI.aka.Sprite(this._textures[0]);
    this._sprite.anchor.set(0.5,0.5);

    if (type == EHDI.game.GridTileTipe.LEFT)
      this._sprite.scale.x = -1;

    this.addChild(this._sprite);
  }

  if (this._countSprite == null) {
    this._countSprite = new EHDI.aka.Sprite(this._textures[5]);
    this._countSprite.anchor.set(0.5,0.4);

    this.addChild(this._countSprite);
  }

  if(this._glowSprite == null) {
    this._glowSprite = new EHDI.aka.Sprite(this._textures[3]);
    this._glowSprite.anchor.set(0.5,0.5);
    this._glowSprite.visible = false;

    if (type == EHDI.game.GridTileTipe.LEFT)
      this._glowSprite.scale.x = -1;

    this.addChild(this._glowSprite);
  }
}

EHDI.game.GridTile.prototype.changeAsset = function(count) {
  if (count == 0) {
    this._sprite.texture = this._textures[0];
    this._countSprite.texture = this._textures[4];
  } else if (count == 1){
    this._sprite.texture = this._textures[2];
    this._countSprite.texture = this._textures[5];
  }
  else if (count == 2){
    this._sprite.texture = this._textures[1];
    this._countSprite.texture = this._textures[6];
  }
 //  else if (count == 3){
 //    this._sprite.texture = this._textures[1];
 //    this._countSprite.texture = this._textures[6];
 // }
}

EHDI.game.GridTile.prototype.addGlow = function() {
  this._glowSprite.visible = true;
}

EHDI.game.GridTile.prototype.removeGlow = function() {
  this._glowSprite.visible = false;
}
